<template>
  <div class="legal-table-container">
    <b-table striped bordered responsive no-border-collapse :items="legalData()" :fields="fields">
      <template v-slot:cell(availability)="data">
        <span>{{ data.value }}</span>
      </template>

      <template v-slot:cell(expiry)="data">
        <span>
          <i class="material-icons" style="color:red; font-size:12px" v-if="!labelExpire(data.value)">warning</i>{{ checkDate(data.value) }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'LegalDocument',
  props: {
    detailId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dateFormat: { day: 'numeric', month: 'short', year: 'numeric' },
      items: [
        { document_name: 'Akta', availability: true, expiry: 1576067992682, remaining_days: 7 },
        { document_name: 'SK Pengesahan', availability: true, expiry: 1576067992682, remaining_days: 7 },
        { document_name: 'SIUP', availability: true, expiry: 1576067992682, remaining_days: 7 },
        { document_name: 'NIB', availability: false, expiry: null, remaining_days: 0 }
      ],
      fields: [
        { key: 'document_name', label: 'Document Name', thClass: 'bg-head' },
        { key: 'availability', label: 'Availability', thClass: 'bg-head' },
        { key: 'expiry', label: 'Expired Date', thClass: 'bg-head' },
        { key: 'remaining_days', label: 'Remaining Expired Days', thClass: 'bg-head' }
      ]
    }
  },
  methods: {
    checkDate(value){
      if(value && moment(value).isValid()){
        return moment(value).format("DD MMM YYYY")
      }
      return '-'
    },
    checkDoc(doc){
      if(doc && doc !== "" && doc !== 'No'){
        return 'Yes'
      } else {
        return 'No'
      }
    },
    checkRemainingDoc(doc){
      if(doc && moment(doc).isValid()){
        const remaining = new Date(doc)
        const convertTime = 1000*60*60*24
        if(((remaining.getTime() - new Date().getTime())/convertTime) < 0){
          return (parseInt(((remaining.getTime() - new Date().getTime())/convertTime))).toString().split('-').join('-  ')
        }
        return parseInt(((remaining.getTime() - new Date().getTime())/convertTime))
      }
      return '-'
    },
    labelExpire(value){
      const remaining = new Date(value)
      const convertTime = 1000*60*60*24
      if(remaining <= new Date()){
        return false
      }
      return true

    },
    legalData(){
      const self = this
      if(self.$store.state.datatable.detail){
        const info = self.$store.state.datatable.detail
        let legalDoc = [
          {
            document_name : 'FORMULIR INFORMASI VENDOR',
            availability : self.checkDoc(info['FORMULIR_INFORMASI_VENDOR']),
            expiry : '-',
            remaining_days : '-',
          },
          {
            document_name : 'INFORMASI REKENING',
            availability : self.checkDoc(info['NOMOR_REKENING']),
            expiry : '-',
            remaining_days : '-',
          },
          {
            document_name : 'KTP',
            availability : self.checkDoc(info['KTP_PENGURUS']),
            expiry : info['KTP_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['KTP_EXPIRED_DATE']),
          },
          {
            document_name : 'KK',
            availability : self.checkDoc(info['KARTU_KELUARGA']),
            expiry : info['KK_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['KK_EXPIRED_DATE']),
          },
          {
            document_name : 'AKTA PENDIRIAN PERSEROAN',
            availability : self.checkDoc(info['AKTA_PENDIRIAN_PERSEROAN']),
            expiry : info['AKTA_PENDIRIAN_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['AKTA_PENDIRIAN_EXPIRED_DATE']),
          },
          {
            document_name : 'AKTA PENYESUAIAN PT',
            availability : self.checkDoc(info['AKTA_PENYESUAIAN_PT']),
            expiry : info['AKTA_PENYESUAIAN_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['AKTA_PENYESUAIAN_EXPIRED_DATE']),
          },
          {
            document_name : 'ANGGARAN DASAR TERAKHIR PERSEROAN',
            availability : self.checkDoc(info['ANGGARAN_DASAR_TERAKHIR_PERSEROAN']),
            expiry : info['AD_PT_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['AD_PT_EXPIRED_DATE']),
          },
          {
            document_name : 'AKTA PERUBAHAN PENGURUS TERAKHIR PERSEROAN',
            availability : self.checkDoc(info['AKTA_PERUBAHAN_PENGURUS_TERAKHIR_PERSEROAN']),
            expiry : info['AKTA_PERUBAHAN_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['AKTA_PERUBAHAN_EXPIRED_DATE']),
          },
          {
            document_name : 'NPWP',
            availability : self.checkDoc(info['NPWP']),
            expiry : info['NPWP_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['NPWP_EXPIRED_DATE']),
          },
          {
            document_name : 'SPPKP PAJAK',
            availability : self.checkDoc(info['SPPKP_PAJAK']),
            expiry : info['SPPKP_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['SPPKP_EXPIRED_DATE']),
          },
          {
            document_name : 'SKT PAJAK',
            availability : self.checkDoc(info['SKT_PAJAK']),
            expiry : info['SKT_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['SKT_EXPIRED_DATE']),
          },
          {
            document_name : 'SK DOMISILI SITU IG',
            availability : self.checkDoc(info['SK_DOMISILI_SITU_IG']),
            expiry : info['SK_DOMISILI_SITU_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['SK_DOMISILI_SITU_EXPIRED_DATE']),
          },
          {
            document_name : 'SIUP',
            availability : self.checkDoc(info['SIUP']),
            expiry : info['SIUP_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['SIUP_EXPIRED_DATE']),
          },
          {
            document_name : 'NIB',
            availability : self.checkDoc(info['NIB']),
            expiry : info['NIB_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['NIB_EXPIRED_DATE']),
          },
          {
            document_name : 'TDP',
            availability : self.checkDoc(info['TDP']),
            expiry : info['TDP_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['TDP_EXPIRED_DATE']),
          },
          {
            document_name : 'SBU',
            availability : self.checkDoc(info['SBU']),
            expiry : info['SBU_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['SBU_EXPIRED_DATE']),
          },
          {
            document_name : 'IUJK',
            availability : self.checkDoc(info['IUJK']),
            expiry : info['IUJK_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['IUJK_EXPIRED_DATE']),
          },
          {
            document_name : 'IU PELAYARAN',
            availability : self.checkDoc(info['IU_PELAYARAN']),
            expiry : info['IU_PELAYARAN_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['IU_PELAYARAN_EXPIRED_DATE']),
          },
          {
            document_name : 'IUJP',
            availability : self.checkDoc(info['IUJP']),
            expiry : info['IUJP_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['IUJP_EXPIRED_DATE']),
          },
          {
            document_name : 'IU NIAGA',
            availability : self.checkDoc(info['IU_NIAGA']),
            expiry : info['IU_NIAGA_EXPIRED_DATE'],
            remaining_days : self.checkRemainingDoc(info['IU_NIAGA_EXPIRED_DATE']),
          },
        ]
        return legalDoc
      }
    }
  },
}
</script>
<style lang="scss">
  @import "~/assets/scss/components/legalDocumentDetail.scss";
</style>
